import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneGeneralPaymentCycle from '../ones/OneGeneralPaymentCycle';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import GeneralPaymentCycleRegistrationForm from "../ones/GeneralPaymentCycleRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState("");
	const [applyStreams, setApplyStreams] = useState("no");
	const [supportedGeneralPaymentCycles, setSupportedGeneralPaymentCycles] = useState([]);

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getAllGeneralPaymentCycles();
		setReady(true);
	}

	function resetClassroomForm() {
		setName("");
		setApplyStreams('no');
		setSupportedGeneralPaymentCycles([]);
	}

	async function createClassroom() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-classroom',
				{
					name,
					applyStreams,
					supportedGeneralPaymentCycles: JSON.stringify(supportedGeneralPaymentCycles),
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					appContext.getAllGeneralPaymentCycles();
					appContext.tellMessage("Successful");
					resetClassroomForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allGeneralPaymentCycles])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.allGeneralPaymentCycles) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							General Payment Cycles
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<h6
									className="sub-section-title"
								>
									Create New General Payment Cycle
								</h6>
								<hr/>

								<GeneralPaymentCycleRegistrationForm/>
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										All General Payment Cycles
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by title"
									/>

								</div>
								<hr/>

								{
									(appContext.allGeneralPaymentCycles && appContext.allGeneralPaymentCycles.length > 0) ?
										appContext.allGeneralPaymentCycles.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.title).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OneGeneralPaymentCycle data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OneGeneralPaymentCycle data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No payment cycle was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}